type LogLevelType = 'debug' | 'error' | 'info' | 'log' | 'trace' | 'warn';

const logger = (logLevel: LogLevelType, ...args: Array<unknown>): void => {
  // eslint-disable-next-line no-console
  console[logLevel](...args);
};

const info = (...args: Array<unknown>): void => {
  logger('info', ...args);
};

const error = (...args: Array<unknown>): void => {
  logger('error', ...args);
};

const warn = (...args: Array<unknown>): void => {
  logger('warn', ...args);
};

const debug = (...args: Array<unknown>): void => {
  logger('debug', ...args);
};

const log = (...args: Array<unknown>): void => {
  logger('log', ...args);
};

export { logger, info, error, warn, debug, log };
